import {useCurrentRepository} from '@github-ui/current-repository'
import {tagPath} from '@github-ui/paths'
import {KebabHorizontalIcon, TagIcon} from '@primer/octicons-react'
import {Box, IconButton, Link, Octicon} from '@primer/react'
import {useState} from 'react'
import type {BranchCommitState} from '../../hooks/use-load-branch-commits'

export interface CommitTagInfoProps {
  data: BranchCommitState
}

export function CommitTagInfo({data}: CommitTagInfoProps) {
  const repo = useCurrentRepository()

  const [tagsExpanded, setTagsExpanded] = useState(false)

  if (data.tags.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderBottomStyle: 'solid',
        borderColor: 'border.default',
        borderWidth: '1px',
        flexWrap: 'wrap',
        p: 3,
      }}
    >
      <Octicon icon={TagIcon} sx={{mr: 2}} />

      <Link
        href={tagPath({owner: repo.ownerLogin, repo: repo.name, tag: data.tags[0]!})}
        sx={{color: 'fg.default', px: 1}}
      >
        {data.tags[0]}
      </Link>
      {data.tags.length > 2 ? (
        tagsExpanded ? (
          data.tags.slice(1, data.tags.length - 1).map(tag => {
            return (
              <Link
                href={tagPath({owner: repo.ownerLogin, repo: repo.name, tag})}
                sx={{color: 'fg.subtle', pl: 2}}
                key={tag}
              >
                {tag}
              </Link>
            )
          })
        ) : (
          <IconButton
            aria-label="Show more tags"
            icon={KebabHorizontalIcon}
            size="small"
            variant="invisible"
            onClick={() => setTagsExpanded(true)}
          />
        )
      ) : null}

      {data.tags.length > 1 ? (
        <Link
          href={tagPath({owner: repo.ownerLogin, repo: repo.name, tag: data.tags[data.tags.length - 1]!})}
          sx={{color: 'fg.subtle', pl: 1}}
        >
          {data.tags[data.tags.length - 1]}
        </Link>
      ) : null}
    </Box>
  )
}

try{ CommitTagInfo.displayName ||= 'CommitTagInfo' } catch {}